"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const PhonePreview_1 = require("../PhonePreview");
const PreviewPortal = ({ children, device, isPhonePreviewActive, isPhonePreviewClosing, startClosingPhonePreview, title, updateActivePhonePreview, }) => isPhonePreviewActive && (React.createElement(React.Fragment, null, ReactDOM.createPortal(React.createElement(PhonePreview_1.default, { animation: `${isPhonePreviewClosing ? 'close' : 'open'} ease-out 350ms`, device: device, buttonLeft: "Close", buttonLeftCallback: () => {
        startClosingPhonePreview();
        setTimeout(() => updateActivePhonePreview(''), 350);
    }, previewTitle: title }, children), document.getElementById('mainModalLeft'))));
const mapStateToProps = (state, ownProps) => ({
    isPhonePreviewActive: reducers_1.getIsPhonePreviewActive(state, ownProps.title),
    isPhonePreviewClosing: reducers_1.getIsPhonePreviewClosing(state),
});
const mapDispatchtoProps = (dispatch) => ({
    updateActivePhonePreview: (preview) => dispatch(actions_1.updateActivePhonePreview(preview)),
    startClosingPhonePreview: () => dispatch(actions_1.startClosingPhonePreview()),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchtoProps)(PreviewPortal);
